import React from "react";
import { SingleVideo } from "./SingleVideo";

export default function FormIntroVideos({ pro, handleVideoAdd }) {
  return (
    <>
      <SingleVideo
        keyName="video1"
        user={pro}
        title="Introduction"
        onChange={(value) => {
          handleVideoAdd("video1", value);
        }}
      />
      <SingleVideo
        keyName="video2"
        user={pro}
        title="Additional Info"
        onChange={(value) => {
          handleVideoAdd("video2", value);
        }}
      />
    </>
  );
}
